module.exports = __webpack_public_path__ + "img/20200801_161649.e6bfe2f1.jpg";